import { SxProps, Theme } from '@mui/material/styles';
import { ReactElement, ReactNode } from 'react';

import { VariantBodyType } from '../../theme/type';

export type RouteProps = {
  children: ReactNode;
  className?: string;
  hash?: string;
  href: string;
  sx?: SxProps<Theme>;
  underline?: boolean;
  variant?: VariantBodyType;
  whiteSpace?: 'normal' | 'nowrap';
};

export enum RoutePath {
  Agb = '/agb',
  AlexanderSolovev = '/alexander-solovev',
  BenjaminKegler = '/benjamin-kegler',
  DanielDonaczi = '/daniel-donaczi',
  Datenschutz = '/datenschutz',
  DimitriErmisch = '/dimitri-ermisch',
  ElenaZander = '/elena-zander',
  EmmanuelBrun = '/emmanuel-brun',
  FalkoZander = '/falko-zander',
  Home = '/',
  Impressum = '/impressum',
  JuJutsu = '/ju-jutsu',
  Kampfkunst = '/kampfkunst',
  KampfkunstFaq = '/kampfkunst/faq',
  KampfkunstInstructorProgram = '/kampfkunst/ausbilder-werden',
  KampfkunstRanking = '/kampfkunst/methode',
  KampfkunstTraining = '/kampfkunst/training',
  KampfkunstVip = '/kampfkunst/vip',
  KampkunstPu = '/kampfkunst/privatunterricht',
  Kontakt = '/kontakt',
  MartinLandolt = '/martin-landolt',
  MichaelProckl = '/michael-prockl',
  Selbstverteidigung = '/selbstverteidigung',
  Sitemap = '/sitemap',
  SolovevStyle = '/solovev-style',
  SystemaRyabko = '/systema-ryabko',
  WaldemarLotz = '/waldemar-lotz',
}

export type Route = {
  element: ReactElement;
  name: string;
  path: RoutePath;
  text: string;
};
